import { render, staticRenderFns } from "./UserRewards.vue?vue&type=template&id=06ff952d&"
import script from "./UserRewards.vue?vue&type=script&lang=js&"
export * from "./UserRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports